import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do general contractors get qualified remodel leads?",
    "a": "Service-specific landing pages for kitchen, bath, additions, and basements — plus a portfolio that signals price point. Generic 'GC services' pages attract handyman shoppers. Specific pages attract real remodelers."
  },
  {
    "q": "Is SEO worth it for a remodeling business?",
    "a": "Yes. 'Kitchen remodeler near me' is one of the highest-intent searches in home services. Ranking captures buyers months before they're ready to start."
  },
  {
    "q": "Should GCs run Google Ads?",
    "a": "Yes for kitchen, bath, and addition searches where average tickets justify the CPC. We build conversion-focused campaigns instead of generic 'remodeling' broad-match spend."
  },
  {
    "q": "How do I stop attracting low-budget leads?",
    "a": "Show your portfolio, budget ranges, and process clearly on the site. Pre-qualify with a multi-step form. Buyers who don't fit drop off before they ever call."
  },
  {
    "q": "Do you work with design-build firms specifically?",
    "a": "Yes — design-build is where most of our GC clients live. We tailor positioning, pricing transparency, and lead forms to a design-build sales process."
  }
];

export const Route = createFileRoute("/general-contractor-marketing-colorado")({
  head: () =>
    industryMarketingHead("General Contractor", "general contractor", "general-contractor-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"General Contractor"}
      industryLower={"general contractor"}
      slug={"general-contractor-marketing-colorado"}
      subheadline={"We help Colorado general contractors and remodelers build a steady pipeline of qualified, ready-to-build homeowners — not tire-kickers."}
      painPoints={["Leads are unqualified — half your consultations don't have budget","Your portfolio is great but your site doesn't show it the right way","You compete with handymen on Google instead of real GCs"]}
      serviceDescriptions={{
        seo: "Rank for kitchen remodel, bath remodel, additions, basements, whole-home — every project type, every Colorado market.",
        googleMaps: "Own 'general contractor near me' so qualified homeowners call you first.",
        webDesign: "Portfolio-led sites with project galleries, budget pre-qualification, and trust-builders that filter out tire-kickers.",
        ppc: "Profitable Google Ads tuned to high-budget kitchen, bath, and addition searches.",
        geoAi: "Get cited when homeowners ask ChatGPT 'best general contractor in Denver' or 'kitchen remodeler near me'.",
        socialMedia: "Project reels and before/afters that build trust and pre-sell prospects before they call.",
      }}
      testimonial={{"quote":"Lead quality changed completely. We're booking $80k–$200k projects from inbound and stopped chasing $5k handyman jobs.","role":"Owner, Design-Build Contractor","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"General contractor marketing in Colorado Springs","description":"Compete with the established remodelers across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"General contractor marketing in Denver","description":"Win high-end kitchen, bath, and addition projects in Denver."},{"to":"/castle-rock-digital-marketing","label":"General contractor marketing in Castle Rock","description":"Custom remodel and luxury home work across Castle Rock and Douglas County."}]}
    />
  ),
});
